import instance from '../utils/axios';

class SaleChanceService {

    async getList(pageIndex, keyword) {
        return await instance.post('/crm/crm/project/getProjectList', {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'chanceId.crm_sale_chance,customerId.crm_customer,advisorId.base_staff',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            fuzzySearch: keyword,
            sortField: 'createTime',
            sort: 'desc'
        });
    }
	async getAttendanceList(pageIndex,projectId) {
		let uuid = "'" + projectId + "'";
	    return await instance.post('/crm/project/attendance/list', {
	        pageSize: 10,
	        pageIndex: pageIndex,
	        dictionaryNames: 'creatorId.base_staff',
	        expressions: '[{"field": "数量", "expression": "count(1)"}]',
	        sortField: 'createTime',
	        sort: 'desc',
			filter: "projectId =" + uuid
	    });
	}
	async getProjectById(projectId) {
	    return await instance.get('/crm/crm/project/getProjectById?t=1584847362927&uuid=' + projectId);
	}
	async getTab(uuid,host) {
	    return await instance.get('/crm/dynamicTab/getSelectedList?host='+host+'&hostPrimaryKey='+uuid);
	}
	 async getFormDataList(pageIndex,id,keyword,formTableName,hostId) {
	    return await instance.post('/crm/dynamicTab/getFormDataList?formTableName='+formTableName, {
	        pageSize: 10,
	        pageIndex: pageIndex,
	        dictionaryNames: 'advisorId.base_staff,advisorId.base_staff.avatar,creatorId.base_staff,creatorId.base_staff.avatar,customerId.crm_customer',
	        expressions: '[{"field": "数量", "expression": "count(1)"}]',
	        sortField: 'createTime',
			fuzzySearch: keyword,
			[hostId]:id,
	        sort: 'asc'
	    });
	}

}

export default new SaleChanceService();